import React from 'react';
import { textCss } from './Css';

const SideBarTab = ({ tabs, openTab, setOpenTab, tabClass = '' }) => {
    return (
        <div className='w-full'>
            <ul className='flex'>
                {tabs.map(({ tabName, tabID }) => {
                    return (
                        <li className='w-full flex justify-center'>
                            <span
                                href='#'
                                className={
                                    `text-font11 font-medium  px-5 py-3 block  leading-normal hover:text-scogoorange cursor-pointer w-full text-center ` +
                                    (openTab === tabID ? ' text-scogoprimary border-b-2 border-scogoprimary bg-white' : ' text-scogogray bg-white')
                                }
                                onClick={(e) => {
                                    setOpenTab(tabID);
                                }}
                                data-toggle='tab'
                                role='tablist'
                            >
                                {tabName}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SideBarTab;
